<template>
    <div :class="(!audit_mode && !previous && !skip_info) ? 'mb-5 pb-5' : 'gray-600 font-scale-sm'">
        <div :class="[{ 'p-3 gray-500 rounded border border-color-gray-300 bgray-100': previous === true }]">
            <b-overlay :show="is_visible_by_pipeline === false" rounded="sm" opacity="0.8" bg-color="#efefef">
                <div v-if="headers">
                    <div class="d-flex align-items-center mb-1 pb-1">
                        <b-badge class="f-80" variant="basic">
                            <template v-if="is_edit_page && label">
                                {{ sub_code_label }}. ( {{ sub_code }} )
                            </template>
                            <template v-else>
                                {{ sub_code_label }}.
                            </template>
                        </b-badge>
                        <template v-if="required_attachment">
                            <b-badge variant="danger" class="f-85 fw-500 ml-1"> {{ $t('첨부필수') }}</b-badge>
                        </template>
                        <template v-if="required_answer">
                            <b-badge variant="warning" class="f-85 fw-500 ml-1"> {{ $t('필수답변') }}</b-badge>
                        </template>

                        <template v-if="!isFieldEmpty(sub_info) && !previous && !skip_info">
                            <b-button :id="`i-${sub_code}`" class="f-80 ml-1 px-1 py-0" variant="teal" size="sm"
                                v-b-toggle="`sub_info-${sub_code}`">
                                <fa icon="book-open"></fa>
                                {{ $t('작성 도움말') }}
                            </b-button>
                        </template>

                        <template v-if="show_previous && !previous">
                            <b-button :id="`p-${sub_code}`" class="f-80 ml-1 px-1 py-0"
                                v-b-toggle="`previous-${sub_code}`" variant="red5" size="sm">
                                <fa icon="history"></fa>
                                {{ $t('과거답변 보기') }}
                            </b-button>
                        </template>
                    </div>

                    <!-- qe previous component -->
                    <template v-if="!print_mode && !previous">
                        <b-collapse :id="`previous-${sub_code}`" class="mb-45">
                            <df-previous-sub :id="`df_radio_previous-${sub_code}`" :sub_code="sub_code"
                                :company_id="company_id" :company_name="company_name" :campaign_id="campaign_id"
                                :sub_id="sub_id" :sub_init_id="sub_init_id" @previous-sub-loaded="updatePrevious" />
                        </b-collapse>
                    </template>

                    <div :class="sub_description ? 'mb-3 pt-1' : 'mb-1'">
                        <div v-if="is_indicate_description" :id="`${form_id}-name`" class="mr-1 d-inline f-105">
                            <span>{{ showTranslation(sub_description, sub_description_e, sub_description_c) }}</span>
                        </div>
                        <span v-for="item in tags" :key="item.id">
                            <b-badge v-if="item" class="ml-2 f-80"> {{ item }} </b-badge>
                        </span>
                        <span v-if="sub_priority">
                            <b-button variant="icon" class="mx-2"> {{ sub_priority }} </b-button>
                        </span>
                    </div>

                    <template v-if="!isFieldEmpty(sub_info) && !skip_info">
                        <b-collapse :id="`sub_info-${sub_code}`" :visible="print_mode"
                            class="rounded mb-3 border-0 teal8 bg-teal2 f-95">
                            <!-- :visible="print_mode !== true && audit_mode !== true && previous !== true" -->
                            <div v-html="showTranslation(sub_info, sub_info_e, sub_info_c)" class="p-3" />
                        </b-collapse>
                    </template>
                </div>

                <!-- Radio 유형 Sub Component -->
                <b-form-radio-group :id="form_id" v-model="sub_data_contents.result" @change="handleChange"
                    :aria-labelledby="headers && is_indicate_description ? `${form_id}-name` : null"
                    :aria-required="required_answer ? 'true' : null"
                    :stacked="!sub_data_header.horizontal || sub_data_header.horizontal === false">
                    <!-- {{ sub_data_contents.result }} -->
                    <div v-for="(item, item_idx) in sub_data_contents.structure" :key="item_idx"
                        :class="[{ 'mb-1': sub_data_contents.structure.length - 1 > item_idx }]">
                        <b-form-radio :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent"
                            :value="item.value" :class="[
                                { 'mb-0': sub_data_contents.structure.length > item_idx && (typeof item['element_contents'] == 'undefined' || !item.element_contents.length) },
                                { 'mb-1': sub_data_contents.structure.length > item_idx && item.element_contents && item.element_contents.length > 0 }
                            ]">
                            <!-- ({{ item.value }}) -->
                            <span class="fw-400"> {{
                                showTranslation(item.text, item.text_ea, item.text_ca)
                            }}</span>
                        </b-form-radio>
                        <div v-if="has_sub_attachment(item)" class="rounded mb-3 border-0 f-95 p-2 bg-tealgray100">
                            <df-attached-file-url-sub class="mt-1" :key="is_loaded" :sub_id="sub_id"
                                :sub_code="sub_code" :sub_init_id="sub_init_id" :sub_path="`structure[${item_idx}]`"
                                :company_id="company_id" :company_name="company_name" :campaign_id="campaign_id"
                                :audit_mode="audit_mode" :previous="previous" :sub_data_contents="sub_data_contents"
                                :label="label" :save_state="save_state"
                                :required_opt_attachment="sub_data_header.required_opt_attachment"
                                :disabled="is_disabled_attached || !sub_data_contents.result">
                            </df-attached-file-url-sub>
                        </div>
                        <df-element v-for="(element_item, element_idx) in item.element_contents"
                            :class="[{ 'mb-2': item.element_contents.length - 1 > element_idx }]"
                            :key="elements_key + element_idx" :for_attachment_info="{
                                ...for_attachment_info,
                                sub_path_name: item.value,
                            }" :item_idx="item_idx" :element_idx="element_idx" :element_item="element_item"
                            :audit_mode="audit_mode" :sub_code="sub_code" :label="label"
                            :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent || item.value != sub_data_contents.result"
                            @change="handleElementChange">
                        </df-element>
                    </div>

                    <template v-if="sub_data_header.enable_na">
                        <b-form-radio :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent"
                            class=" mt-1 mb-2" value="해당없음">
                            <span class="fw-400">{{ enable_na_label || $t('해당없음') }}</span>
                        </b-form-radio>
                    </template>
                </b-form-radio-group>

                <template v-if="not_applicable">
                    <div class="px-4 mt-1">
                        <b-form-input v-model="sub_data_contents.na_reason" aria-describedby="input-live-feedback"
                            :placeholder="$t(`본 질문이 귀사에 해당사항이 없는 구체적 이유를 입력해 주세요.`)" @update="textInputSave"
                            @blur="textInputSave(true, true)" :state="na_state"
                            :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent" trim>
                        </b-form-input>
                        <b-form-invalid-feedback id="na-reason-feedback">
                            {{ $t('해당없음의 이유가 불충분 하거나 부적절한 경우 인정되지 않을 수 있습니다.') }}
                        </b-form-invalid-feedback>
                    </div>
                </template>

                <!-- file 저장 -->
                <template v-if="sub_data_header.has_attachment">
                    <df-attached-file-url class="mt-3" :key="is_loaded" :sub_id="sub_id"
                        :sub_code="sub_code" :sub_init_id="sub_init_id" :company_id="company_id"
                        :company_name="company_name" :campaign_id="campaign_id" :audit_mode="audit_mode"
                        :previous="previous" :label="label" :has_attachment="sub_data_header.has_attachment"
                        :disabled="is_disabled_attached">
                    </df-attached-file-url>
                </template>

                <!-- 저장 validation -->
                <div v-if="previous != true && audit_mode != true" :class="validation_style" @click="retrySave" class="pt-2 float-right" role="status" aria-live="polite">
                    <fa v-if="validation_icon != ''" :icon="validation_icon"></fa>
                    {{ validation_comment }}
                </div>

                <!-- Child Component -->
                <sub-component v-for="(item, index) in child_subs" :key="item.id" :sub_type="item.sub_type" :item="item"
                    :audit_mode="audit_mode" :is_final_sub_component="index == child_subs.length - 1 ? true : false"
                    :is_disabled_by_parent="is_disabled_by_parent"
                    :disabled="is_locked || is_disabled_by_condition || is_disabled_by_parent">
                </sub-component>

                <!-- is_visible_by_pipeline 조건에 따른 해당없음 overlay -->
                <template v-slot:overlay>
                    <DFPipelineOverlay :prev_sub_info="prev_sub_info" :pipeline_title="pipeline_title" />
                </template>
            </b-overlay>
        </div>

        <!-- previous component
        <b-collapse v-if="print_mode!=true" :id="previous_sub.sub_code">
            <sub-component :disabled="true" v-if="previous_sub.sub_code != undefined && previous != true" :is_disabled_by_parent="true" :sub_type="previous_sub.sub_type" :item="previous_sub" :previous="true"></sub-component>
        </b-collapse>
        -->
    </div>
</template>

<script>
import { SubComponentMixin } from '@core_mixins/SubComponentMixin'
import DFElement from '@core_components/client/components/subs/elements/DFElement'
import DFPreviousSub from '@core_components/client/components/subs/previous_sub/DFPreviousSub'
import DFPipelineOverlay from "@core_components/client/components/subs/elements/DFPipelineOverlay";
import DfAttachedFileUrlSub from "@core/components/client/components/subs/elements/DFAttachedFileURLSub.vue";
import { mapActions, mapState } from "vuex";
import { unlinkWarning } from "@core/utils/subComponent/unlinkWarning";

export default {
    name: 'df-radio',
    mixins: [SubComponentMixin],
    components: {
        DfAttachedFileUrlSub,
        DFPipelineOverlay,
        'df-element': DFElement,
        'df-previous-sub': DFPreviousSub
    },
    data() {
        return {
            elements_key: Math.floor(Math.random() * 1000000),
            show_previous: false,
            old_val: null
        }
    },
    computed: {
        ...mapState('questions', ['subs']),
        has_sub_attachment() {
            return (item) => {
                if (this.sub_data_contents?.result == null) return false
                if (this.sub_data_contents.result === '아니오') return false
                return (this.sub_data_header.required_opt_attachment && this.sub_data_contents.result === item.value && this.sub_id) && ((item.element_contents?.length ?? 0) === 0)
            }
        },
        for_attachment_info() {
            return {
                sub_id: this.sub_id,
                sub_init_id: this.sub_init_id,
                company_id: this.company_id,
                company_name: this.company_name,
                campaign_id: this.campaign_id,
                previous: this.previous,
                is_loaded: this.is_loaded,
                required_opt_attachment: this.sub_data_header.required_opt_attachment,
                sub_data_contents: this.sub_data_contents,
                save_state: this.save_state
            }
        }

    },
    updated() { },
    watch: {
        is_loaded: {
            immediate: true,
            handler(new_val) {
                if (new_val == true) {
                    this.elements_key += 10
                }
            }
        },
        'sub_data_contents.result': {
            handler(new_val, old_val) {
                this.old_val = old_val
            }
        }
    },
    methods: {
        ...mapActions('attachments', ['unlinkAttachments']),
        async handleChange() {
            let unlink_sub_attachments_obj = {}
            const temp_sub_data_contents = JSON.parse(JSON.stringify(this.sub_data_contents))
            // 현 항목 첨부파일 제거
            temp_sub_data_contents.structure.forEach((item, itemIdx) => {
                if (typeof item.attachments !== 'undefined') {
                    if (item.value !== this.sub_data_contents.result) {
                        // 선택한 답안이 아니면
                        item.attachments.forEach((attachment) => {
                            const sub_path = `structure[${itemIdx}]`
                            unlink_sub_attachments_obj[`${attachment}-${sub_path}`] = {
                                sub_path,
                                storage_id: attachment
                            }
                        })
                        item.attachments = []
                    }
                }
            })

            // 하위 항목 및 하위 항목 첨부파일 제거
            temp_sub_data_contents.structure.forEach((item, itemIdx) => {
                if (typeof item.element_contents !== 'undefined') {
                    if (item.value !== this.sub_data_contents.result) {
                        // 선택한 답안이 아니면
                        item.element_contents.forEach((element_item, element_itemIdx) => {
                            // 하위 질문을 모두 삭제
                            if (['input_text', 'input_number'].includes(element_item.type)) {
                                element_item.result = ''
                                this.elements_key += 10 //for reactivity

                                if (element_item.structure.attachments != null && element_item.structure.attachments.length > 0) {
                                    const sub_path = `structure[${itemIdx}].element_contents[${element_itemIdx}].structure`
                                    element_item.structure.attachments.forEach((attachment) => {
                                        unlink_sub_attachments_obj[`${attachment}-${sub_path}`] = {
                                            sub_path,
                                            storage_id: attachment
                                        }
                                    })
                                }
                            } else if (element_item.type == 'table') {
                                element_item.result = ''
                                element_item.structure.forEach(row => {
                                    element_item.table_header.forEach(header => {
                                        if (!row.noteditables.includes(header)) {
                                            row[header] = ''
                                        }
                                    })
                                })
                                if (element_item.attachments != null && element_item.attachments.length > 0) {
                                    const sub_path = `structure[${itemIdx}].element_contents[${element_itemIdx}]`
                                    element_item.attachments.forEach((attachment) => {
                                        unlink_sub_attachments_obj[`${attachment}-${sub_path}`] = {
                                            sub_path,
                                            storage_id: attachment
                                        }
                                    })
                                }

                            } else if (element_item.type === 'checkbox') {
                                element_item.result.splice(0, element_item.result.length)

                                element_item.structure.forEach((element_checkbox_item, element_checkbox_itemIdx) => {
                                    if (typeof element_checkbox_item.description !== 'undefined') {
                                        element_checkbox_item.description = ''
                                    }
                                    if (element_checkbox_item.attachments != null && element_checkbox_item.attachments.length > 0) {
                                        element_checkbox_item.attachments.forEach((attachment) => {
                                            const sub_path = `structure[${itemIdx}].element_contents[${element_itemIdx}].structure[${element_checkbox_itemIdx}]`
                                            unlink_sub_attachments_obj[`${attachment}-${sub_path}`] = {
                                                sub_path,
                                                storage_id: attachment
                                            }
                                        })
                                        element_checkbox_item.attachments = []
                                    }
                                })
                            }
                            else if (element_item.type === 'radio') {
                                element_item.result = ''
                                element_item.attachments = []

                                element_item.structure.forEach((element_radio_item, element_radio_itemIdx) => {
                                    if (typeof element_radio_item.description !== 'undefined') {
                                        element_radio_item.description = ''
                                    }
                                    if (element_radio_item.attachments != null && element_radio_item.attachments.length > 0) {
                                        element_radio_item.attachments.forEach((attachment) => {
                                            const sub_path = `structure[${itemIdx}].element_contents[${element_itemIdx}].structure[${element_radio_itemIdx}]`
                                            unlink_sub_attachments_obj[`${attachment}-${sub_path}`] = {
                                                sub_path,
                                                storage_id: attachment
                                            }
                                        })
                                        element_radio_item.attachments = []
                                    }
                                })
                            }
                        })
                    }
                }
            })

            const unlink_sub_attachments = Object.values(unlink_sub_attachments_obj)
            if (unlink_sub_attachments.length > 0) {
                const h = this.$createElement;

                unlinkWarning(this, h)
                    .then(async (value) => {
                        if (!value) {
                            this.sub_data_contents.result = this.old_val
                            return
                        }
                        const promiseList = []
                        unlink_sub_attachments.forEach(elem => {
                            promiseList.push(
                                this.unlinkAttachments({
                                    sub_id: this.sub_id,
                                    company_id: this.for_attachment_info.company_id.toString(),
                                    campaign_id: this.for_attachment_info.campaign_id.toString(),
                                    sub_path: elem.sub_path,
                                    storage_id: [elem.storage_id],
                                })
                            )
                        })
                        await Promise.all(promiseList)
                        await this.proceedRadioSave(temp_sub_data_contents)
                    })
            }
            else {
                await this.proceedRadioSave(temp_sub_data_contents)
            }
        },
        async proceedRadioSave(temp_sub_data_contents = null) {
            if (temp_sub_data_contents) {
                const target_sub_idx = this.subs.findIndex(x => x.sub_code === this.sub_code)
                if (target_sub_idx >= 0) {
                    this.$set(this.subs[target_sub_idx], 'sub_data_contents', temp_sub_data_contents)
                }
            }


            //calculate score
            this.$nextTick(() => {
                if (this.sub_data_header.scoring && this.sub_data_header.scoring === 'auto') {
                    let temp_score = 0
                    let idx = this.sub_data_contents.structure.findIndex(x => {
                        return x.value === this.sub_data_contents.result
                    })
                    if (idx > -1) {
                        if (this.sub_data_contents.structure[idx].score) {
                            temp_score += Number(this.sub_data_contents.structure[idx].score)
                        }
                    }
                    this.score_result = temp_score
                }
            })

            await this.radioSave()

        },
        handleElementChange(item_idx, element_idx, new_element_item, type, is_blur) {
            this.sub_data_contents.structure[item_idx].element_contents[element_idx] = new_element_item

            this.$nextTick(() => {
                if (type === 'checkbox' || type === 'radio') {
                    this.radioSave()
                }
                else {
                    this.textInputSave(true, is_blur)
                }
                // this.handleChange()
            })
        },
        updatePrevious(flag) {
            this.show_previous = flag
        }
    }
}
</script>

<style></style>
